"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleError = handleError;

var _capitalFinderApi = _interopRequireDefault(require("@alliedcrowds/capital-finder-api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function handleError(error, context) {
  if (error instanceof _capitalFinderApi["default"].apiException) {
    context.dispatch('addMessage', {
      text: error.message,
      title: error.name,
      type: 'error',
      duration: 5000
    });
  }
}


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/js/errors.js